// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"5771ba47","677":"e6814138","754":"483a7b70"}[chunkId] + ".chunk.js";
};